import Image from 'next/legacy/image';

export default function DorikPaste() {
  return (
    <li>
      <h3 id="paste-dorik">Paste it in your Dorik website</h3>
      <p>
        Click on <code>Add Element</code> in an empty row and section. From the{' '}
        <code>General Elements</code> section, select <code>IFrame</code>
      </p>
      <p>Paste the copied URL</p>
      <Image src="/guides/dorik-paste.gif" width={1424} height={665} alt="dorik editor" />
      <p>
        <a href="https://help.dorik.com/en/article/iframe-dj5e36/">Learn More</a>
      </p>
    </li>
  );
}
